import { ComponentWithAs, Icon } from '@chakra-ui/react';
import { IIconProps } from '~/components/Icon/Icon';

export const StarIcon: ComponentWithAs<'svg', IIconProps> = (props) => (
  <Icon
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.9241 3.21573C9.3643 2.32392 10.636 2.32393 11.0762 3.21573L12.8707 6.8512L16.8847 7.4379C17.8686 7.58171 18.2607 8.79112 17.5484 9.48491L14.6449 12.3129L15.33 16.3075C15.4981 17.2878 14.4691 18.0354 13.5887 17.5724L10.0002 15.6852L6.4116 17.5724C5.53124 18.0354 4.50219 17.2878 4.67033 16.3075L5.35544 12.3129L2.45192 9.48491C1.7396 8.79112 2.13175 7.58171 3.11564 7.4379L7.12959 6.8512L8.9241 3.21573ZM10.0002 3.74687L8.20564 7.38235C8.03099 7.73617 7.69357 7.98152 7.30315 8.03859L3.2892 8.62529L6.19272 11.4533C6.47576 11.729 6.60496 12.1264 6.53817 12.5158L5.85306 16.5103L9.44161 14.6231C9.79127 14.4393 10.209 14.4393 10.5587 14.6231L14.1472 16.5103L13.4621 12.5158C13.3953 12.1264 13.5245 11.729 13.8076 11.4533L16.7111 8.62529L12.6972 8.03859C12.3067 7.98152 11.9693 7.73617 11.7947 7.38235L10.0002 3.74687Z"
      fill="currentColor"
    />
  </Icon>
);
